import { Injectable } from '@angular/core';
import Swal, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';
import { environment } from '@environments/environment';

declare let ePayco: {
  checkout: {
    configure: (options: { key: string; test: boolean }) => EpaycoHandler;
  };
};

interface EpaycoHandler {
  open: (data: Record<string, unknown>) => void;
}

/* Documentación: https://docs.epayco.com/docs/integracion-personalizada */
interface IpayProps {
  price: number;
  inserted: string;
  paymentName: string;
  paymentDescription: string;
  showCashOption?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class EpaycoCheckoutService {
  public handler: EpaycoHandler | null = null;

  public swalOpts: SweetAlertOptions = {
    showCancelButton: true,
    cancelButtonText: 'Cancelar',
    showConfirmButton: true,
    confirmButtonColor: '#fd8140',
    reverseButtons: true,
  };
  //epayco keys
  private _noCashOptions = {
    [environment.epaycoKeys.card]: 'Tarjeta crédito o débito',
  };
  private _cashOptions = {
    [environment.epaycoKeys.card]: 'Tarjeta crédito o débito',
    [environment.epaycoKeys.cash]: 'Efectivo',
  };
  // Epayco payment
  public data = {
    //Parametros compra (obligatorio)
    name: 'Estudio de historia crediticia',
    description: 'Pago de acuerdo de pago',
    invoice: '',
    currency: 'cop',
    amount: '12000',
    tax_base: '0',
    tax: '0',
    country: 'co',
    lang: 'es',

    //Onpage="false" - Standard="true"
    external: "false",
    confirmation: environment.checkout.confirmation,
    response: environment.checkout.response,
    //response: "https://fianly-testing-front.herokuapp.com/checkout/resultado-trasaccion",

    //Atributos cliente
    // name_billing: "Andres Perez",
    // address_billing: "Carrera 19 numero 14 91",
    //type_doc_billing: "cc",
    //mobilephone_billing: "3007054635",
    //number_doc_billing: "100000000",

    //atributo deshabilitación metodo de pago
    //methodsDisable: ["TDC", "PSE","SP","CASH","DP"]
  };

  async pay({
    price,
    inserted,
    paymentName,
    paymentDescription,
    showCashOption = false,
  }: IpayProps) {
    this.data.name = paymentName;
    this.data.description = paymentDescription;
    this.data.invoice = inserted.toString();
    this.data.amount = price.toString();

    const inputOptions: Record<string, string> = showCashOption
      ? this._noCashOptions
      : this._cashOptions;

    Swal.fire({
      ...this.swalOpts,
      title: 'Elige el método de pago',
      input: 'radio',
      inputOptions: inputOptions,
      confirmButtonText: 'Aceptar',
      inputValidator: (value) =>
        !value ? 'Debes elegir un método de pago' : null,
    }).then((result: SweetAlertResult<string>) => {
      if (result.value) {
        this.handler = ePayco.checkout.configure({
          key: result.value,
          test: true,
        });
        this.handler.open(this.data);
      } else return;
    });
  }
}
